import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Link as RouterLink } from 'react-router-dom';
import {
  Card,
  CardContent,
  Grid,
  Typography,
  Avatar,
  Button,
  CardActions
} from '@material-ui/core';
import SecurityIcon from '@material-ui/icons/Security';
import CardActionArea from '@material-ui/core/CardActionArea';

const useStyles = makeStyles(theme => ({
  root: {
    height: "100%"
  },
  card: {
    height: "100%"
  },
  title: {
    fontWeight: 700
  },
  icon: {
    height: 32,
    width: 32
  },
  avatar: {
    float: 'right',
    backgroundColor: theme.palette.primary.main,
    height: 56,
    width: 56
  },
  cardFooter: {
    padding: "0 15px 15px 15px",
    position: "absolute",
    bottom: 0,
    width: "100%",
  }
}));

const Security = props => {
  const { className, data, ...rest } = props;

  const classes = useStyles();

  return (

    <CardActionArea className={classes.root} component={RouterLink} to={"/settings/security"}>
      <Card
        {...rest}
        className={classes.card}
      >
        <CardContent>
          <Grid container direction="row" wrap="nowrap" justify="space-between" spacing={2}>
            <Grid item xs={10}>
              <Grid container direction="column"
                justify="flex-start"
                alignItems="stretch"
                spacing={3}>
                <Grid item>
                  <Typography className={classes.title} color='textSecondary' variant="body1">
                    Sécurité de l'application
                  </Typography>
                </Grid>
                <Grid item>
                  <Grid container justify='flex-start' alignItems='flex-start' direction='column'>
                    <Grid item>
                      <Typography variant="body2">
                        Temps d'inactivité avant déconnexion : <strong>{data.maxConnectionTime == '0' ? 'Ilimité' : `${data.maxConnectionTime}H`}</strong>
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Typography variant="body2">
                        Sécurité minimale des mots de passe : <strong>{data.strenghtPassword}</strong>
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Typography variant="body2">
                        Durée avant réinitialisation du mot de passe : <strong>{data.resetPassword} jours</strong>
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={2}>
              <Avatar className={classes.avatar}>
                <SecurityIcon className={classes.icon} />
              </Avatar>
            </Grid>
          </Grid>
        </CardContent>
        <CardActions>
          <Button color="primary" fullWidth>
            Configurer la sécurité
          </Button>
        </CardActions>
      </Card>
    </CardActionArea >
  );
};

export default Security;
